exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nth[data-v-2a57a720] {\n  padding: 5px;\n}\n.content-tlist[data-v-2a57a720] {\n  overflow: scroll;\n  max-width: 1500px;\n  max-height: 100vh;\n}\n\n", ""]);

// exports
